import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { User } from '../_models/user.model';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ProfileService } from './profiles.service';
import { EnvironmentService } from './environment.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MsalService, BroadcastService } from "@azure/msal-angular";
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient,
              private profilesService: ProfileService,
              private environmentService: EnvironmentService,
              private router: Router,
              private authB2c: MsalService,
              ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  checkUserToken() {
    let options = {};
    if (this.currentUserValue && this.currentUserValue.authToken) {
      options = {};
    } else {
      options = {};
    }
    return this.http.
      //get(`${this.environmentService.apiUrl}/Login`, options)
      get(`${this.environmentService.apiUrl}/Login?token=${this.currentUserValue.authToken}`)
        .pipe(map((response: any) => {
          if (response !== 'Valid token'){
            Swal.fire("Sesión ha expirado, por favor ingrese nuevamente");
            this.logout();
            this.router.navigate(['/login']);
          }
          return response;

        }));
  }

  login(userToken: string) {
    return this.http.
      post<any>(`${this.environmentService.apiUrl}/Login`, { loginToken: userToken })
        .pipe(map((user: User) => {
          // Login exitoso si se devuelve un token
          if (user && user.authToken) {
            // Obtención de Username (Afiliado, No_Afiliado, Empresa y Windows).
            user.UserName = user.NombreLargo.split('|').slice(-1)[0];
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
          } else {
            this.currentUserSubject.next(null);
          }
          // Devolver respuesta de solicitud.
          return user;
        }));
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.profilesService.setSelectedProfile(-1);
    this.currentUserSubject.next(null);
  }
}
